import { AddToListButton } from './AddToListButton'

export default AddToListButton
